import * as actionTypes from "./actionTypes";
import axios from "../../http/axios";

const getAlertsSuccess = data => {
  return {
    type: actionTypes.GET_ALERTS_SUCCESS,
    payload: data
  };
};

const getAlertSuccess = data => {
  return {
    type: actionTypes.GET_ALERT_SUCCESS,
    payload: data
  };
};

const getOrdersSuccess = data => {
  return {
    type: actionTypes.GET_ORDERS_SUCCESS,
    payload: data
  };
};

const getOrderSuccess = data => {
  return {
    type: actionTypes.GET_ORDER_SUCCESS,
    payload: data
  };
};

const getRestaurantsSuccess = data => {
  return {
    type: actionTypes.GET_RESTAURANTS_SUCCESS,
    payload: data
  };
};

const getAlertsFailed = data => {
  console.log("Error getting Alerts");
};

const getAlertFailed = data => {
  console.log("Error getting Alert");
};

const getOrdersFailed = data => {
  console.log("Error getting Orders");
};

const getOrderFailed = data => {
  console.log("Error getting Order");
};

const getRestaurantsFailed = data => {
  console.log("Error getting Order");
};


export const getAlerts = (page, status) => {
    return (dispatch, getState) => {
        let url = `/alerts/`;
        if (status) {
            url = `${url}?status=${status}&show_all=true`
        }
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem('token');
        }
        axios.get(url, {
            headers: { Authorization: "JWT " + token }
        } )
            .then( response => {
                dispatch(getAlertsSuccess(response.data));
            } )
            .catch( error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                } else {
                  return {};
                    dispatch(getAlertsFailed(error));
        }
      });
  };
};

export const getAlert = id => {
  return (dispatch, getState) => {
    let url = `/alerts/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    return axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getAlertSuccess(response.data));
        return Promise.resolve(response.data);
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          return {};
          dispatch(getAlertFailed(error));
        }
      });
  };
};

export const getUserData = id => {
  return (dispatch, getState) => {
    let url = `/users/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch({
          type: "GET_USER_SUCCESS",
          payload: response.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getDriverData = id => {
  return (dispatch, getState) => {
    let url = `/drivers/${id}/`;
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch({
          type: "GET_DRIVER_SUCCESS",
          payload: response.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getOrders = (page = 1, searchValue, forMap) => {
  return (dispatch, getState) => {
    let url = `/orders/`;
// received, confirmed, prepared, on_the_way, 5_mins_away, arrived
    if (forMap) {
      url = `${url}?status=on_the_way&status=received&status=confirmed&status=prepared&status=5_mins_away&status=arrived&show_all=true`;
    } else {
      url = `${url}?page=${page}`;
      if (searchValue) {
        url = `${url}&search=${searchValue}`;
      }
    }
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(url, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getOrdersSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          return {};
          dispatch(getOrdersFailed(error));
        }
      });
  };
};

export const getOrder = id => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get("/orders/" + id + "/", {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch(getOrderSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          dispatch(getOrderFailed(error));
        }
      });
  };
};

export const getRestaurantData = id => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(`/restaurants/${id}/`, {
        headers: { Authorization: "JWT " + token }
      })
      .then(response => {
        dispatch({
          type: "GET_RESTAURANT",
          payload: response.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const getBranchData = id => {
    return (dispatch, getState) => {
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem("token");
        }
        axios
            .get(`/branches/${id}/`, {
                headers: { Authorization: "JWT " + token }
            })
            .then(response => {
                dispatch({
                    type: "GET_BRANCH",
                    payload: response.data
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 403) {
                    dispatch({ type: actionTypes.AUTH_SIGNOUT });
                }
            });
    };
};

export const changeAlertStatus = (id, data) => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    return axios
      .patch(`/alerts/${id}/`, data, {
        headers: { Authorization: "JWT " + token }
      })
      .then(res => res)
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        }
      });
  };
};

export const changeOrderStatus = (id, data) => {
    return (dispatch, getState) => {
        let token = getState().auth.token;
        const doesRemember = getState().auth.doesRemember;
        if (doesRemember) {
            token = localStorage.getItem('token');
        }
        return axios.patch( `/orders/${id}/`, data, {
            headers: { Authorization: "JWT " + token }
        } ).then(res => res).catch(error => {
            if (error.response && error.response.status === 403) {
                dispatch({ type: actionTypes.AUTH_SIGNOUT });
            }
        });
    };
};

export const getRestaurants = () => {
  return (dispatch, getState) => {
    let token = getState().auth.token;
    const doesRemember = getState().auth.doesRemember;
    if (doesRemember) {
      token = localStorage.getItem("token");
    }
    axios
      .get(
        "/restaurants/?show_all=true",
        {
          headers: { Authorization: "JWT " + token }
        }
      )
      .then(response => {
        dispatch(getRestaurantsSuccess(response.data));
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          dispatch({ type: actionTypes.AUTH_SIGNOUT });
        } else {
          return {}
          dispatch(getRestaurantsFailed(error));
        }
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/operations.js